import { createI18n } from "vue-i18n";
import deDE from "./locales/de_DE.json";
import enEN from "./locales/en_US.json";
import type { I18n } from "vue-i18n";
import { AppLanguage } from "@/constants";
import { de, en } from "vuetify/locale";
import { buildI18nMessage } from "@polargold/pg-frontend-core";


const messages = {
    de: buildI18nMessage(deDE, de),
    en: buildI18nMessage(enEN, en),
};

// noinspection JSDeprecatedSymbols
export const i18n: I18n = createI18n({
    legacy: false,
    locale: AppLanguage.German,
    fallbackLocale: AppLanguage.German,
    messages
});
